module.exports = __webpack_public_path__ + "img/token.72b9f5d3.svg";